import { ServiceBase } from './ServiceBase'

export class Assets extends ServiceBase {}
